import React, { Component } from 'react';
import LoadingBar from '../../components/global/loadingBar';
import { ReactComponent as Back } from '../../../assets/svg/chevron-left.svg';
import { ReactComponent as Delete } from '../../../assets/svg/delete.svg';
import InputHeader from '../../components/global/inputwithHeader';
import { gql } from '@apollo/client';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import { withRouter } from '../../../services/withRoute';
import Select from 'react-select';
import _ from 'lodash';
import equipmentConstants from '../../../utils/equipmentConstants';
var randomize = require('randomatic');

const registerEquipments = gql`
	mutation RegisterVendorEq($branchId: String!, $equipmentInput: RegisterEqInput) {
		registerVendorEq(branchId: $branchId, equipmentInput: $equipmentInput) {
			message
		}
	}
`;

const getBranchList = gql`
	query BranchesList {
		branchesList {
			id
			code
			branchId
			description
			address
			city
			state
		}
	}
`;

const getEquipment = gql`
	query EquipmentList($eqIdentifier: [String!]!) {
		equipmentInfo(eqIdentifier: $eqIdentifier) {
			id
			model
			manufacturer
			description
			status
			type
			qrCode
			lastUsedBy {
				userName
				eventId
				projectId
				userId
			}
		}
	}
`;

class RegisterEquipments extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			isLoading: false,
			qrCode: '',
			isEQFetching: false,
			qrCodeError: false,
			eqFetched: false,
			equipments: [],
			branchId: null,
			qrCodeError: false,
			qrCodeErrorMessage: '',
			uploadBatchID: randomize('Aa0', 10),
			typeOptionsList: equipmentConstants.equipment.types,
			modelOptionsList: equipmentConstants.equipment.models,
			manufacturerOptionsList: equipmentConstants.equipment.manufacturers,
			serialNumberRequiredTypes: equipmentConstants.equipment.serialNumberRequiredTypes,
			descriptionOptionsList: equipmentConstants.equipment.descriptions,
		};
	}

	componentDidMount = () => {
		this.getBranchList(getBranchList);
	};
	isDisabled = () => {
		let manufacturerIdRequirement =
			_.size(
				_.filter(this.state.equipments, (equipment) => {
					return _.indexOf(this.state.serialNumberRequiredTypes, equipment.type) >= 0;
				}),
			) ===
			_.size(
				_.filter(this.state.equipments, (equipment) => {
					return (
						_.indexOf(this.state.serialNumberRequiredTypes, equipment.type) >= 0 &&
						_.has(equipment, 'manufacturerId') &&
						equipment.manufacturerId != ''
					);
				}),
			)
				? true
				: false;

		let basicRequirements =
			_.size(this.state.equipments) ===
			_.size(
				_.filter(this.state.equipments, (equipment) => {
					return (
						_.has(equipment, 'type') &&
						_.has(equipment, 'qrCode') &&
						_.has(equipment, 'manufacturer') &&
						_.has(equipment, 'description')
					);
				}),
			)
				? true
				: false;

		if (
			_.size(this.state.equipments) == 0 ||
			this.state.branchId === null ||
			basicRequirements === false ||
			manufacturerIdRequirement === false
		) {
			return true;
		} else {
			return false;
		}
	};
	handleBranchChange = (e) => {
		this.setState({
			branchId: e.value,
		});
	};

	handleRegisterMCs = (e) => {
		let json = {
			branchId: this.state.branchId,
			equipmentInput: {
				equipments: this.state.equipments,
				/* notes: {
					message: null,
					files: null,
				}, */
				files: [],
				batchId: this.state.uploadBatchID,
			},
		};

		this.registerAssets(registerEquipments, json, 'equipments');
	};
	handleQrCode = async (e, type) => {
		this.setState({
			qrCode: e.target.value.toUpperCase(),
			qrCodeError: false,
			qrCodeErrorMessage: '',
		});
		if (e.target.value !== '' && e.target.value.length == 8) {
			if (_.size(_.filter(this.state.equipments, { qrCode: e.target.value })) > 0) {
				this.setState({
					qrCodeError: true,
					qrCodeErrorMessage: 'QR code  already scanned',
				});
			} else if (
				await this.getEquipmentInfo(
					getEquipment,
					{
						eqIdentifier: e.target.value,
					},
					null,
					null,
					true,
				)
			) {
				this.setState({
					qrCodeError: true,
					qrCodeErrorMessage: 'QR code already registered',
				});
			} else {
				let equipments = this.state.equipments;
				let json = {
					qrCode: e.target.value,
				};
				if (_.size(equipments) > 0) {
					json = { ...equipments[0], ...json };
				}
				equipments.push(json);
				this.setState({
					equipments,
					qrCode: '',
					qrCodeError: false,
				});
			}
		}
	};

	handleInput = (e, type, key) => {
		let value = _.has(e, 'target') ? e.target.value : e.value;
		let equipments = this.state.equipments;
		if (type === 'type') {
			equipments[key] = {
				qrCode: this.state.equipments[key]['qrCode'],
				[type]: value,
			};
		} else {
			equipments[key] = { ...this.state.equipments[key], [type]: value };
		}

		this.setState({
			equipments,
		});
	};

	deleteItem = (e, qrCode) => {
		let equipments = [...this.state.equipments];
		this.setState({
			equipments: _.filter(equipments, function (o) {
				return o.qrCode !== qrCode;
			}),
		});
	};

	renderEquipmentsTable = () => {
		return (
			<div className="qrCodeTable">
				<div className="header">
					<span>qr code</span>
					<span>CATEGORY *</span>
					<span>manufacturer *</span>
					<span>SERIAL NUMBER</span>
					<span>MODEL</span>
					<span>DESCRIPTION *</span>
					<span>Comments</span>
					<span></span>
				</div>
				{_.map(this.state.equipments, (equipment, key) => {
					return (
						<div className="row">
							<span>{equipment.qrCode}</span>
							<span className="mc-reg">
								<Select
									key={equipment.type + '-' + key}
									className={`cost-select-container cost-select-container-eq ${
										'zIndex' + (30 - key)
									} w-100p`}
									classNamePrefix="cost-select"
									options={_.sortBy(this.state.typeOptionsList, ['value'])}
									onChange={(e) => this.handleInput(e, 'type', key)}
									isSearchable={true}
									defaultValue={_.find(this.state.typeOptionsList, {
										value: equipment.type,
									})}
								/>
							</span>
							<span className="mc-reg">
								<Select
									key={equipment.type + '-' + key}
									className={`cost-select-container cost-select-container-eq ${
										'zIndex' + (30 - key)
									} w-100p`}
									classNamePrefix="cost-select"
									options={_.sortBy(this.state.manufacturerOptionsList, [
										'value',
									])}
									onChange={(e) => this.handleInput(e, 'manufacturer', key)}
									isSearchable={true}
									defaultValue={_.find(this.state.manufacturerOptionsList, {
										value: equipment.manufacturer,
									})}
								/>
							</span>
							<span>
								<input
									key={equipment.type + '-' + key}
									value={equipment.manufacturerId}
									onChange={(e) => this.handleInput(e, 'manufacturerId', key)}
								/>
								{_.indexOf(this.state.serialNumberRequiredTypes, equipment.type) >=
								0
									? '*'
									: ''}
							</span>

							<span className="mc-reg">
								<Select
									key={equipment.type + '-' + key}
									className={`cost-select-container cost-select-container-eq ${
										'zIndex' + (30 - key)
									} w-100p`}
									classNamePrefix="cost-select"
									options={_.sortBy(
										_.filter(this.state.modelOptionsList, {
											type: equipment.type,
										}),
										['value'],
									)}
									onChange={(e) => this.handleInput(e, 'model', key)}
									isSearchable={true}
									defaultValue={_.find(this.state.modelOptionsList, {
										value: equipment.model,
									})}
								/>
							</span>

							<span className="mc-reg">
								<Select
									key={equipment.type + '-' + key}
									className={`cost-select-container cost-select-container-eq ${
										'zIndex' + (30 - key)
									} w-100p`}
									classNamePrefix="cost-select"
									options={_.sortBy(
										_.filter(this.state.descriptionOptionsList, {
											type: equipment.type,
										}),
										['value'],
									)}
									onChange={(e) => this.handleInput(e, 'description', key)}
									isSearchable={true}
									defaultValue={_.find(this.state.descriptionOptionsList, {
										value: equipment.description,
									})}
								/>
							</span>
							<span>
								<input
									key={equipment.type + '-' + key}
									value={equipment.comment}
									onChange={(e) => this.handleInput(e, 'comment', key)}
								/>
							</span>
							<span onClick={(e) => this.deleteItem(e, equipment.qrCode)}>
								<Delete />
							</span>
						</div>
					);
				})}
			</div>
		);
	};

	renderEquipmemntsTableContainer = () => {
		return (
			<div className="arc-body">
				<div className="remap-equipment-container">
					<div className="rec-left">
						<div className="floating-select-container" style={{ marginBottom: '30px' }}>
							<label>
								Branch
								<span className="required-star">*</span>
							</label>
							<Select
								key={_.size(this.state.branchesListOption)}
								className={
									'cost-select-container zIndex31 w-100p' +
									(this.state.isSuspended ? ' cost-select--is-disabled' : '')
								}
								classNamePrefix="cost-select"
								options={this.state.branchesListOption}
								onChange={(e) => this.handleBranchChange(e)}
								defaultValue={_.find(this.state.branchesListOption, {
									value: this.state.branchId,
								})}
								isSearchable={true}
							/>
						</div>
						<input
							className="qrcode"
							value={this.state.qrCode}
							placeholder="Type QR Code"
							autoFocus={true}
							onChange={(e) => this.handleQrCode(e, 'qrCode')}
						/>
						{this.state.isEQFetching ? (
							<div className={'loading-btn'}>
								<LoadingBar />
							</div>
						) : (
							''
						)}
						{this.state.qrCodeError ? (
							<p
								style={{
									color: 'red',
									fontSize: 13,
								}}
							>
								{this.state.qrCodeErrorMessage}
							</p>
						) : (
							''
						)}
						{_.size(this.state.equipments) > 0 ? (
							this.renderEquipmentsTable()
						) : (
							<div className="empty-mcs">
								No Equipments Added <br /> Please scan or type in the equipment ID
							</div>
						)}
					</div>
				</div>
			</div>
		);
	};
	render() {
		return (
			<>
				{this.state.isLoading ? (
					<div
						style={{
							position: 'relative',
							height: 'calc(100vh - 102px)',
							width: 'calc(100vw - 403px)',
						}}
					>
						<LoadingBar />
					</div>
				) : (
					<div
						className="assign-receive-container"
						style={{ width: '100%', marginLeft: 0 }}
					>
						<div className="arc-header">
							<div className="back-btn" onClick={(e) => this.goBack(e)}>
								<Back />
							</div>
							<div className="arch-item">
								<span>Admin Tools</span>
							</div>
							<div className="next-btn">
								{' '}
								<Back />
							</div>

							<div className="arch-item">
								<span>Register Equipments</span>
							</div>
							<div className="actn-btn">
								<a
									onClick={(e) => {
										if (!this.isDisabled()) {
											this.handleRegisterMCs(e);
										}
									}}
									className={this.isDisabled() ? 'isDisabledBtn' : ''}
								>
									Register Equipments
								</a>
							</div>
						</div>
						{this.renderEquipmemntsTableContainer()}
					</div>
				)}
			</>
		);
	}
}

export default withRouter(RegisterEquipments);
